'use client';

import { useEffect, useRef, useState } from 'react';
import NewsStrip from '../../components/NewsStrip';
import Swiper from '../../components/Swiper';
import { twMerge } from 'tailwind-merge';
import { IPost } from '../../../models/ICategory';
import { SwiperProps } from 'swiper/react';

interface Props {
  data: {
    posts: IPost[];
    category: {
      title: string;
      uniqueCode: string;
    }
  }
  setSelected: (idx: number) => void;
  selected?: number;
  locale: string;
  device?: string;
}

export default function CategorySwiper({ setSelected, data, locale, selected, device }: Props) {

  const swiperRef = useRef<any>();

  const toggleAutoplay = (play: boolean) => {
    if (play) swiperRef.current.swiper.autoplay.start();
    else swiperRef.current.swiper.autoplay.stop();
  }


  return (
    <Swiper
      ref={swiperRef}
      swiperSlideProps={{
        className: 'py-[16px] desktop:py-[0]'
      }}
      swiperProps={{
        // onSlideChange: (swiper) => {
        //   const activeSlideKey = swiper.slides.find(x => x.classList.contains('swiper-slide-next'));
        //   const id = activeSlideKey?.getAttribute('data-swiper-slide-index') as string;
        //   if (typeof id === 'string') setSelected(Number(id));
        // },
      }}
      slides={data.posts.map((p, i) => <NewsStrip
        locale={locale}
        onMouseEnter={() => {
          toggleAutoplay(false);
          setSelected(i);
        }}
        onMouseLeave={() => {
          toggleAutoplay(true);
        }}
        device={device}
        key={p.uniqueCode}
        data={{
          post: {
            ...p,
            imageProps: { priority: i <= 3, loading: i <= 3 ? 'eager' : 'lazy' }
          },
          category: { title: data.category.title, slug: data.category.uniqueCode }
        }}
        className={twMerge(i === selected && 'desktop:hover:scale-[1.025]')} />
      )}
    />
  )
}